import { useCallback, useState } from 'react';
import { StatusType } from 'components/common/StatusBadge';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useTaskByIdQuery, useTaskStatusChangeMutation } from 'api';

export const useTaskInfo = ({ id }: { id: string }) => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { handleError, handleSuccess } = useNotificationMessages();
  const { data: taskDetails = {} } = useTaskByIdQuery({ id });
  const [changeStatus] = useTaskStatusChangeMutation();

  const onModalStateChange = useCallback(() => {
    setModalState((oState) => !oState);
  }, []);

  const handleStatusChange = useCallback(
    async (status: StatusType) => {
      try {
        const { data, error }: any = await changeStatus({ taskId: id, status });
        if (data?.success) {
          handleSuccess('The task status was successfully changed.');
        } else {
          handleError(error);
        }
      } catch (err) {
        console.log(err, 'error');
      }
    },
    [handleSuccess, changeStatus, id, handleError]
  );
  return {
    handleStatusChange,
    taskDetails,
    modalState,
    onModalStateChange,
  };
};
